module.exports = __webpack_public_path__ + "img/Main_leftArrow.4ee4bff3.png";